import clsx from 'clsx';

// Components
import Divider from '@/components/base/Divider/Divider';
// Types
import type { Winner } from '@/components/pages/giveaway-picker/Types/drawTypes';

type WinnerProps = {
    winner: Winner;
    index: number;
    totalWinners?: number;
    isExtraWinner?: boolean;
};

export function Winner({ winner, index, totalWinners, isExtraWinner }: WinnerProps) {
    return (
        <div
            className={clsx(
                'relative col-span-6 flex items-center gap-6 rounded-lg bg-icoGray-100 px-6 py-8',
                {
                    'flex-col': !isExtraWinner,
                    'md:col-span-2':
                        (totalWinners === 4 && index >= 2) ||
                        (totalWinners === 5 && index >= 2) ||
                        totalWinners === 3,
                    'md:col-span-3':
                        (totalWinners === 5 && index === 0) ||
                        (totalWinners === 5 && index === 1) ||
                        totalWinners === 2,
                    'md:col-span-6': totalWinners === 1
                }
            )}>
            {totalWinners > 1 && !isExtraWinner ? (
                <span className="absolute left-3 top-3 flex h-6 w-6 items-center justify-center rounded-full bg-icoBlue font-GBold text-xs text-white">
                    {index + 1}
                </span>
            ) : null}
            <span
                className={clsx(
                    'flex items-center justify-center rounded-full bg-icoBlue-100 text-icoBlue',
                    {
                        'h-12 w-12 text-xl': isExtraWinner,
                        'h-14 w-14 text-2xl': !isExtraWinner
                    }
                )}>
                {winner.username.charAt(0).toUpperCase()}
            </span>

            <span
                className={clsx('w-full flex-1 break-words break-all', {
                    'space-y-6 text-center': !isExtraWinner,
                    'space-y-2': isExtraWinner
                })}>
                <p className="text-xl">{winner.username}</p>
                {!isExtraWinner ? <Divider /> : null}
                <p className="text-xs">{winner.text}</p>
            </span>
        </div>
    );
}
